/**
 * @generated SignedSource<<c6322f5779c5d7fb06a5b2928e5ef602>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SharedMobileDeviceAuthRequestStatus = "ACCEPTED" | "PENDING" | "REJECTED" | "WAITING_FOR_CONFIRMATION";
export type UserAdminCreateGroupDeviceSubscription$variables = {
  deviceCode: string;
};
export type UserAdminCreateGroupDeviceSubscription$data = {
  readonly sharedMobileDeviceAuthRequestUpdated: {
    readonly deviceCode: string;
    readonly nameSuggestion: string | null;
    readonly status: SharedMobileDeviceAuthRequestStatus;
  } | null;
};
export type UserAdminCreateGroupDeviceSubscription = {
  response: UserAdminCreateGroupDeviceSubscription$data;
  variables: UserAdminCreateGroupDeviceSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "deviceCode"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "deviceCode",
        "variableName": "deviceCode"
      }
    ],
    "concreteType": "SharedMobileDeviceAuthRequest",
    "kind": "LinkedField",
    "name": "sharedMobileDeviceAuthRequestUpdated",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deviceCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nameSuggestion",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserAdminCreateGroupDeviceSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserAdminCreateGroupDeviceSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fe2c610689ae5faf67d2ef092e33b5ed",
    "id": null,
    "metadata": {},
    "name": "UserAdminCreateGroupDeviceSubscription",
    "operationKind": "subscription",
    "text": "subscription UserAdminCreateGroupDeviceSubscription(\n  $deviceCode: String!\n) {\n  sharedMobileDeviceAuthRequestUpdated(deviceCode: $deviceCode) {\n    deviceCode\n    status\n    nameSuggestion\n  }\n}\n"
  }
};
})();

(node as any).hash = "fa4f56d8c3539232ec6c8b02b7518466";

export default node;
